<template>
  <div v-if="!loading" class="container-fluid">
    <div class="row filter">
      <div v-if="options.allowLocationSearch" class="col-md-4">
        <label class="label">Departure Airport</label>
        <APCAutocomplete
          v-popover:popover
          :default-value="airport.name"
          left-icon="bx bxs-plane-alt"
          @submit="airport = $event"
          @focus="popover = false"
        />
        <el-popover
          ref="popover"
          v-model="popover"
          trigger="manual"
          placement="bottom-start"
          popper-class="popover popover-danger"
        >
          <div class="popover-body">Please enter your departure airport.</div>
        </el-popover>
      </div>
      <div class="col-md-5">
        <label class="label">Check-In / Check-Out</label>
        <APCDateRangePicker
          :initial-range="dateRange"
          :max-length="options.maxReservationDays"
          @update="updateDateRange"
        />
      </div>
      <div>
        <label class="label">Coupon Code</label>
        <fg-input
          :value="couponCode"
          placeholder="Coupon Code"
          @input="
            setCouponCode($event.target.value)
          "
        />
      </div>
      <div class="col-md-3">
        <n-button
          type="danger"
          class="btn-search"
          block
          @click.native="onSearch"
        >
          {{ search ? "" : "Update" }}
          <i v-if="search" class="bx bx-loader bx-spin" />
        </n-button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7 col-xl-5 offer-list">
        <div class="row">
          <div class="col-12 offer-list-count">
            {{
              offer && offer.offersDescription
                ? offer.offersDescription
                : "No options available"
            }}
          </div>
          <perfect-scrollbar>
            <div v-if="offer" class="col-12">
              <card v-for="offer in offer.offers" :key="offer.id" plain>
                <div
                  slot="raw-content"
                  class="row offer"
                  @mouseover="hoveredOfferId = offer.id"
                  @mouseout="hoveredOfferId = null"
                >
                  <div class="col-md-3 d-none d-md-block">
                    <div class="card-image">
                      <img
                        :src="offer.locationLogo"
                        class="img img-raised rounded logo"
                      />
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col-md-7">
                          <div class="d-none d-md-block">
                            <h4 class="card-title">{{ offer.locationName }}</h4>
                            <h6 class="category text-primary">
                              {{ offer.name }}
                            </h6>
                          </div>
                          <div
                            class="row align-items-center mb-3 d-flex d-md-none"
                          >
                            <div class="col-auto pr-0">
                              <img
                                slot="image"
                                :src="offer.locationLogo"
                                class="rounded"
                                width="50"
                                alt=""
                              />
                            </div>
                            <div class="col">
                              <h4 class="card-title mt-0">
                                {{ offer.locationName }}
                              </h4>
                              <h6 class="category text-primary">
                                {{ offer.name }}
                              </h6>
                            </div>
                          </div>
                          <div
                            v-for="amenitie in offer.amenities"
                            :key="amenitie.name"
                            class="amenitie"
                          >
                            <i :class="amenitie.icon" class="bx mr-1" />{{
                              amenitie.name
                            }}
                          </div>
                        </div>
                        <div class="col-md-5 d-none d-md-block text-right">
                          <div :class="offer.cost.displayPrice.saleRate !== offer.cost.displayPrice.originalRate ? 'discounted' : ''" class="display-price">
                            <div class="row align-items-center justify-content-end">
                              <div class="col-auto original-price">
                                <h3 class="mb-0">
                                  <sup>$</sup>{{ formatter(offer.cost.displayPrice.originalRate)
                                  }}<sup>{{
                                    formatter(offer.cost.displayPrice.originalRate, 1)
                                  }}</sup>
                                </h3>
                              </div>
                              <div class="col-auto discount-price">
                                <h3 class="mb-0">
                                  <sup>$</sup>{{ formatter(offer.cost.displayPrice.saleRate)
                                  }}<sup>{{
                                    formatter(offer.cost.displayPrice.saleRate, 1)
                                  }}</sup>
                                </h3>
                              </div>
                            </div>
                            <div>
                              <span class="per-day">Daily Rate</span>
                            </div>
                          </div>
                          <n-button
                            :disabled="!offer.available"
                            class="mb-1 mt-2"
                            type="info"
                            @click.native="onSelectOffer(offer)"
                          >
                            Select Deal
                          </n-button>
                          <div v-if="offer.cost.displayPrice.saleRate !== offer.cost.displayPrice.originalRate">
                            <h4 class="my-0 text-secondary">{{ offer.cost.displayPrice.discountText }}</h4>
                          </div>
                          <img
                            v-if="!offer.available"
                            src="img/sold-out.png"
                            class="sold-out"
                            height="56"
                          />
                        </div>
                        <div class="col-12 d-block d-md-none">
                          <div class="row align-items-center mt-2">
                            <div class="col-auto">
                              <div :class="offer.cost.displayPrice.saleRate !== offer.cost.displayPrice.originalRate ? 'discounted' : ''" class="display-price">
                                <div class="row align-items-center justify-content-end">
                                  <div class="col-auto original-price">
                                    <h3 class="mb-0">
                                      <sup>$</sup>{{ formatter(offer.cost.displayPrice.originalRate)
                                      }}<sup>{{
                                        formatter(offer.cost.displayPrice.originalRate, 1)
                                      }}</sup>
                                    </h3>
                                  </div>
                                  <div class="col-auto discount-price">
                                    <h3 class="mb-0">
                                      <sup>$</sup>{{ formatter(offer.cost.displayPrice.saleRate)
                                      }}<sup>{{
                                        formatter(offer.cost.displayPrice.saleRate, 1)
                                      }}</sup>
                                    </h3>
                                  </div>
                                </div>
                              </div>
                              <span class="per-day">Daily Rate</span>
                            </div>
                            <div class="col text-right">
                              <n-button
                                :disabled="!offer.available"
                                class="m-0"
                                type="info"
                                @click.native="onSelectOffer(offer)"
                              >
                                Select Deal
                              </n-button>
                              <div v-if="offer.cost.displayPrice.saleRate !== offer.cost.displayPrice.originalRate">
                                <h4 class="my-0 text-secondary">{{ offer.cost.displayPrice.discountText }}</h4>
                              </div>
                            </div>
                            <img
                              v-if="!offer.available"
                              src="img/sold-out.png"
                              class="sold-out"
                              height="56"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
      <div class="col-lg-5 col-xl-7 map-wrapper">
        <gmap-map
          v-show="!loading"
          ref="gMap"
          :center="center"
          :options="{ scrollwheel: false }"
          :zoom="14"
          class="map"
        >
          <gmap-marker :position="center" icon="img/airport-icon.png" />
          <gmap-marker
            v-for="(offer, index) in markers"
            :key="offer.id"
            :class="hoveredOfferId === offer.id ? 'marker-hover' : ''"
            :label="{
              text: '$' + offer.dailyBaseRate,
              className:
                hoveredOfferId === offer.id && !offer.available
                  ? 'marker-label'
                  : '',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'normal',
            }"
            :position="{
              lat: offer.coordinate.coordinates[1],
              lng: offer.coordinate.coordinates[0],
            }"
            :icon="
              hoveredOfferId === offer.id
                ? 'img/parker-hover.png'
                : 'img/parker.png'
            "
            :z-index="hoveredOfferId === offer.id ? 999 : 100 + index"
            @mouseover="hoveredOfferId = offer.id"
            @mouseout="hoveredOfferId = null"
          />
        </gmap-map>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import { Popover } from "element-ui";
import { Button, Card, FormGroupInput } from "@/components";
import APCAutocomplete from "@/pages/components/APCAutocomplete.vue";
import APCDateRangePicker from "@/pages/components/APCDateRangePicker.vue";
export default {
  components: {
    Card,
    [Popover.name]: Popover,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    APCAutocomplete,
    APCDateRangePicker,
  },
  props: {
    initialOffer: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      airport: {
        coordinate: {
          coordinates: [],
        },
      },
      dateRange: {},
      popover: false,
      search: false,
      isChanged: false,
      offer: null,
      center: {
        lat: 40.748817,
        lng: -73.985428,
      },
      hoveredOfferId: null,
      couponCode: '',
    };
  },
  computed: {
    ...mapState(["loading", "options"]),
    markers() {
      if (this.offer) {
        const markers = Object.assign([], this.offer.offers);
        markers.sort((a, b) =>
          a.dailyBaseRate < b.dailyBaseRate
            ? 1
            : b.dailyBaseRate < a.dailyBaseRate
            ? -1
            : 0
        );

        return markers;
      } else {
        return [];
      }
    },
  },
  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {
        if (newQuery.airportCode !== oldQuery.airportCode) {
          this.getOffers(
            newQuery.airportCode,
            this.dateRange.startDate,
            this.dateRange.endDate
          );
        }
      }
    },
    offer() {
      this.fitBounds();
    },
    airport() {
      this.isChanged = true;
    },
    dateRange() {
      this.isChanged = true;
    },
  },
  created() {
    let { airportCode, name, lat, lng, start, end, couponCode } = this.$route.query;
    if (couponCode) {
      sessionStorage.setItem('couponCode', couponCode);
      this.couponCode = couponCode;
    } else if (sessionStorage.getItem('couponCode')) {
      this.couponCode = sessionStorage.getItem('couponCode');
    }
    if (start && end) {
      this.dateRange.startDate = moment(start).toDate();
      this.dateRange.endDate = moment(end).toDate();
    } else {
      this.dateRange = {
        startDate: moment().add(1, "days").startOf("hour").toDate(),
        endDate: moment().add(5, "days").startOf("hour").toDate(),
      };
      start = moment(this.dateRange.startDate).format("YYYY-MM-DD HH:mm");
      end = moment(this.dateRange.endDate).format("YYYY-MM-DD HH:mm");
    }
    if (lat && lng) {
      this.center.lat = Number(this.$route.query.lat);
      this.airport["coordinate"]["coordinates"][1] = this.$route.query.lat;
      this.center.lng = Number(this.$route.query.lng);
      this.airport["coordinate"]["coordinates"][0] = this.$route.query.lng;
    } else if (this.options.defaultAirport["coordinate"]["coordinates"]) {
      this.center.lat =
        this.options.defaultAirport["coordinate"]["coordinates"][1];
      this.center.lng =
        this.options.defaultAirport["coordinate"]["coordinates"][0];
    }
    if (name) {
      this.airport['name'] = this.$route.query.name;
    }
    if (airportCode) {
      this.airport["code"] = this.$route.query.airportCode;
      if (!this.initialOffer) {
        this.getOffers(
          this.airport.code,
          this.dateRange.startDate,
          this.dateRange.endDate
        );
      } else {
        this.setLoading(false);
        this.offer = this.initialOffer;
      }
    } else {
      this.airport = this.options.defaultAirport;
      const params = {
        airportCode: this.airport.code,
        start,
        end,
        lat: this.airport.coordinate.coordinates[1] || this.center.lat,
        lng: this.airport.coordinate.coordinates[0] || this.center.lng,
      };
      this.$router.push({ name: "/offers", query: { ...params } });
      this.getOffers(
        this.airport.code,
        this.dateRange.startDate,
        this.dateRange.endDate
      );
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getOffers(code, start, end) {
      const startDate = moment(start).format("YYYY-MM-DD");
      const endDate = moment(end).format("YYYY-MM-DD");
      const startTime = moment(start).format("HH:mm");
      const endTime = moment(end).format("HH:mm");
      let query = `apc/offer?airportCode=${code}&startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}`;
      if (sessionStorage.getItem('couponCode')) {
        query += `&couponCode=${sessionStorage.getItem('couponCode')}`;
      }
      axios.get(query).then((res) => {
        const { data } = res;
        console.log("offer: ", data);
        const offers = data.offers.sort((a, b) =>
          a.available < b.available || b.dailyBaseRate < a.dailyBaseRate
            ? 1
            : b.available < a.available || a.dailyBaseRate < b.dailyBaseRate
            ? -1
            : 0
        );
        this.offer = {
          offersDescription: data.offersDescription,
          offers,
        };
        this.isChanged = false;
        this.search = false;
        this.setLoading(false);
      });
    },
    updateDateRange($event) {
      this.dateRange = $event;
      this.getOffers(this.airport.code, this.dateRange.startDate, this.dateRange.endDate);
    },
    fitBounds() {
      setTimeout(() => {
        this.$refs.gMap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds();
          console.log("fitBounds", this.offer, this.airport);
          if (this.offer && this.offer.offers && this.offer.offers.length > 0) {
            if (this.offer.offers.length > 1) {
              this.offer.offers.forEach((offer) => {
                bounds.extend(
                  new google.maps.LatLng(
                    offer.coordinate.coordinates[1],
                    offer.coordinate.coordinates[0]
                  )
                );
              });
              // if (
              //   this.airport.coordinate.coordinates[1] &&
              //   this.airport.coordinate.coordinates[0]
              // )
              //   bounds.extend(
              //     new google.maps.LatLng(
              //       this.airport.coordinate.coordinates[1],
              //       this.airport.coordinate.coordinates[0]
              //     )
              //   );
              map.fitBounds(bounds);
            } else {
              map.setCenter({lat: this.offer.offers[0].coordinate.coordinates[1], lng: this.offer.offers[0].coordinate.coordinates[0]})
            }
          } else if (this.airport.coordinate.coordinates[1] && this.airport.coordinate.coordinates[0]) {
            map.setCenter({lat: this.airport.coordinate.coordinates[1], lng: this.airport.coordinate.coordinates[0]})
          }
        });
      }, 0);
    },
    onSearch() {
      if (!this.couponCode) {
        sessionStorage.removeItem('couponCode');
      }
      if (this.couponCode && this.couponCode !== sessionStorage.getItem('couponCode')) {
        sessionStorage.setItem('couponCode', this.couponCode);
      }
      let code;
      if (this.$route.query.airportCode) {
        code = this.$route.query.airportCode;
      } else {
        code = this.options.allowLocationSearch
          ? this.airport.code
          : this.options.defaultAirport.code;
        if (!code) {
          this.popover = true;
          return;
        }
      }
      
      const start = moment(this.dateRange.startDate).format("YYYY-MM-DD HH:mm");
      const end = moment(this.dateRange.endDate).format("YYYY-MM-DD HH:mm");
      this.search = true;
      if (this.isChanged) {
        const params = {
          name: this.airport.name,
          airportCode: this.airport.code,
          start,
          end,
          lat: this.airport.coordinate.coordinates[1],
          lng: this.airport.coordinate.coordinates[0],
        };
        this.$router.push({ name: "/offers", query: { ...params } });
      }
      this.getOffers(code, start, end, "/offers");
      this.center = {
        lat: Number(this.airport.coordinate.coordinates[1]),
        lng: Number(this.airport.coordinate.coordinates[0]),
      };
    },
    formatter(number, index = 0) {
      return ("" + number.toFixed(2)).split(".")[index];
    },
    onSelectOffer(offer) {
      const startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      const startTime = moment(this.dateRange.startDate).format("HH:mm");
      const endTime = moment(this.dateRange.endDate).format("HH:mm");
      this.$router.push({
        name: "/reservation",
        params: { initialOffer: offer },
        query: {
          id: offer.rateId,
          start: startDate + " " + startTime,
          end: endDate + " " + endTime,
          name: this.airport.name,
          airportCode: this.airport.code,
          lat: this.airport["coordinate"]["coordinates"][1],
          lng: this.airport["coordinate"]["coordinates"][0],
        },
      });
    },
    setCouponCode(cp) {
      this.couponCode = cp;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  align-items: flex-end;
  padding-top: 16px;
  padding-bottom: 5px;
  @media (min-width: 1024px) {
    max-width: 991px;
  }
}
.offer-list {
  border-top: 1px solid #555357;

  .offer-list-count {
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #555357;
  }

  .ps {
    @media (min-width: 772px) {
      height: calc(100vh - 230px);
      width: 100%;
    }

    .card-plain {
      margin-bottom: 0;
      border-bottom: 1px solid;
      border-radius: 0;

      .offer {
        align-items: center;
        &:hover {
          background-color: #5553571a;
        }

        .card-image {
          @media (max-width: 772px) {
            padding-top: 16px;
            text-align: center;

            .logo {
              width: 120px;
            }
          }
        }

        .sold-out {
          position: absolute;
          right: 16px;
          top: 30%;
          transform: rotate(-25deg);

          @media (max-width: 768px) {
            top: 0;
            transform: rotate(-20deg);
          }
        }

        .display-price {
          .discount-price {
            display: none;
          }
          &.discounted {
            .original-price {
              font-size: 75%;
              h3 {
                position: relative;
              }
              h3::after {
                content: '';
                height: 1px;
                width: 100%;
                position: absolute;
                left: 0;
                top: 45%;
                transform: translateY(-50%);
                background-color: red;
              }
            }
            .discount-price {
              display: flex;
              color: red;
            }
          }
        }
      }
    }
  }
}
.map-wrapper {
  height: calc(100vh - 176px);
  padding: 0 !important;
  background-color: #5553571a;
  .map {
    height: 100%;
  }
}

::v-deep .marker-label {
  text-decoration-line: line-through;
}
</style>
